import { DotLoading } from './custom-dot-loading';
import { GaugeLoading } from './custom-gauge';
import { LoadingPage } from './custom-loading-page';
import { WifiLoading } from './wifi-loading';
import { ProgressLoading } from './custom-progress';
import { RoundLoading } from './custom-round-loading';
import { WrapperLoading } from './custom-wrapper-loading';

const CustomLoading = {
    Progress: ProgressLoading,
    Gauge: GaugeLoading,
    Round: RoundLoading,
    Dot: DotLoading,
    Wifi: WifiLoading,
    Wrapper: WrapperLoading,
    LoadingPage: LoadingPage,
};

export default CustomLoading;
